import React, {useState} from "react";
import {Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid,} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SelectComponent from "../components/core/SelectComponent";
import {rerunClaim} from "../utils/API";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {isInsurerUser, isVitrayaInternalUser} from "../constants/UserAuth";

const ReRunClaim = (props) => {
    const {claimId, corporateCode, setRefresh, disabled,enablerestartocr} = props;

    const [open, setOpen] = useState(false);
    const [sendToInsurer, setSendToInsurer] = useState(false);
    const [isSubmitAllow, setIsSubmitAllow] = useState(false);
    const [type, setRerunType] = useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setRerunOptions = (props) => {
        if (props.id && props.type) {
            setRerunType(props.type);
            setIsSubmitAllow(true);
        }
    };

    const rerun = async () => {
        const response = await rerunClaim({
            claimId: claimId,
            claimFlow: type,
            corporateCode: corporateCode,
            sendToInsurer: sendToInsurer
        });

        if (response) {
            setRefresh(true);
            setOpen(false);
        }
    };

    const getRerunOptions = () => {

        const options = [
            {id: "RESTART_ALL", name: "Restart All Module"},
            // { id: "RESTART_BILL_TARIFF", name: "Restart Bill Tariff" },
            {id: "RESTART_PML", name: "Restart PML"},
            {id: "RESTART_VNEURON", name: "Restart vNeuron"},
            {
                id: "RESTART_BILL_TARIFF_AND_PML",
                name: "Restart Bill Tariff and PML",
            },
            { id: "RESTART_OCR", name: "Restart OCR" }
            // {
            //   id: "RESTART_BILL_TARIFF_AND_VNEURON",
            //   name: "Restart Bill Tariff and VNeuron",
            // },
            // {
            //   id: "RESTART_PML_AND_VNEURON",
            //   name: "Restart PML and VNeuron",
            // },
            ];
        // If NOT PREAUTH → remove PRE_AUTH_OCR

        if (!enablerestartocr) {
            return options.filter(option =>
                option.id !== "RESTART_OCR"
            );
        }

        // If PREAUTH → show all

        return options;
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={handleClickOpen}
                sx={{textAlign: "center"}}
                endIcon={<RestartAltIcon/>}
                disabled={disabled}
            >
                Re-Run
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                //scroll={'paper'}
                maxWidth={"md"}
                fullWidth
            >
                <Grid
                    container
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItem: "space-between",
                    }}
                >
                    <Grid item>
                        <DialogTitle sx={{textAlign: "center"}}>
                            {" "}
                            Re-Run Claim{" "}
                        </DialogTitle>
                    </Grid>
                    <Grid
                        item
                        onClick={handleClose}
                        style={{cursor: "pointer", padding: 10}}
                    >
                        <CloseIcon/>
                    </Grid>
                </Grid>

                <DialogContent>
                    <Container>
                        <Grid sx={{maxWidth: "60%"}}>
                            {isVitrayaInternalUser() &&
                                (<>
                                    <SelectComponent
                                        label={"Rerun Options"}
                                        menuItem={getRerunOptions()}
                                        setSelections={(type) =>
                                            setRerunOptions({
                                                type: type,
                                                id: claimId,
                                                hospitalCode: corporateCode,
                                            })
                                        }
                                        style={{margin: 0}}
                                    />
                                    <Checkbox value={sendToInsurer}
                                              onChange={(e, newValue) => setSendToInsurer(newValue)}
                                              inputProps={{"aria-label": "controlled"}}
                                    />
                                    <label>Send To Insurer</label>
                                </>)
                            }
                            {isInsurerUser() && (<h3>Are you sure to re-run claim ?</h3>)}
                        </Grid>
                    </Container>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" onClick={rerun} disabled={!isSubmitAllow}>
                        Confirm
                    </Button>

                    <Button variant="contained" onClick={handleClose} color="error">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
        ;
};

export default ReRunClaim;
